import type { ConsoleLevel } from "../core/events";
import {
  describeStatus,
  formatConsoleArgs,
  formatConsoleSite,
  type TimelineState,
} from "../core/timeline";

const LEVEL_STYLE: Record<ConsoleLevel, string> = {
  log: "text-fg",
  info: "text-fg",
  debug: "text-fg-dark",
  warn: "text-yellow",
  error: "text-red1",
};

const LEVEL_MARK: Record<ConsoleLevel, string> = {
  log: "›",
  info: "ℹ",
  debug: "·",
  warn: "⚠",
  error: "✖",
};

/** Guest console output plus the run's status line (docs/ui-design.md §4). */
export function ConsolePane({ timeline }: { timeline: TimelineState }) {
  return (
    <div data-testid="console" className="font-mono text-[13px]">
      <ol aria-label="Console output">
        {timeline.console.map((entry, i) => (
          <li
            // biome-ignore lint/suspicious/noArrayIndexKey: entries are append-only
            key={i}
            data-level={entry.level}
            className={`flex gap-2 border-b border-border/40 px-3 py-0.5 ${LEVEL_STYLE[entry.level]}`}
          >
            <span aria-hidden className="w-3 shrink-0 text-center">
              {LEVEL_MARK[entry.level]}
            </span>
            <span className="sr-only">{entry.level}:</span>
            <span className="min-w-0 flex-1 whitespace-pre-wrap break-words">
              {formatConsoleArgs(entry.args)}
            </span>
            {entry.site && (
              <span className="shrink-0 text-comment">{formatConsoleSite(entry.site)}</span>
            )}
          </li>
        ))}
      </ol>
      <p data-testid="run-status" role="status" className="px-3 py-1 text-comment">
        ─ {describeStatus(timeline)}
      </p>
    </div>
  );
}
